import { useCallback, useEffect, useState } from "react";

/**
 * Countdown hook — used for approval expiration timers, OTP resend cooldowns, etc.
 */
export function useCountdown(seconds: number) {
  const [remaining, setRemaining] = useState(seconds);

  useEffect(() => {
    if (remaining <= 0) return;

    const timer = setInterval(() => {
      setRemaining((prev) => Math.max(0, prev - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, [remaining]);

  const reset = useCallback(
    (newSeconds?: number) => {
      setRemaining(newSeconds ?? seconds);
    },
    [seconds],
  );

  return { remaining, isExpired: remaining <= 0, reset };
}
